import { useEffect, useState } from 'react';
import { getLicense } from 'api/newUniprofile';
import { ILicense, LicenseForm, INewUniprofileResume } from 'types/newUniprofile';
import { ELicenseType } from 'types/common';
import { getUrlParam } from 'utils/common';
import uniprofileResumeStore from 'store/UniprofileResume';

const DefaultLicense: LicenseForm = {
    identification: {
        type: '',
        frontUrl: '',
        backUrl: '',
        fullFrontUrl: '',
        fullBackUrl: '',
    },
    practiceLicense: [],
    malpracticeInsuranceCertificate: undefined,
    deaLicense: undefined,
    collaboratingPhysician: [],
    additionalLicensesNCertificates: {
        controlledSubstanceCertification: [],
        continuingMedicalEducationCertificates: [],
        autonomy: undefined,
        other: undefined,
    },
};

const formatLicenseData = (res: ILicense) => {
    const licenses = res.licenses || [];
    return {
        identification: res.identification,
        practiceLicense: licenses.filter(
            (item) =>
                item.type === ELicenseType.PRACTICE || !Object.values(ELicenseType).includes(item.type as ELicenseType),
        ),
        deaLicense: licenses.filter((item) => item.type === ELicenseType.DEA),
        malpracticeInsuranceCertificate: licenses.filter((item) => item.type === ELicenseType.MIC)[0],
        collaboratingPhysician: res.physicianList,
        additionalLicensesNCertificates: {
            controlledSubstanceCertification: licenses.filter(
                (item) => item.type === ELicenseType.CONTROLLED_SUBSTAN_CECERTIFICATION,
            ),
            continuingMedicalEducationCertificates: licenses.filter(
                (item) => item.type === ELicenseType.CONTINUING_MEDICAL_EDUCATION_CERTIFICATES,
            ),
            autonomy: licenses.filter((item) => item.type === ELicenseType.AUTONOMY)[0],
            other: licenses.filter((item) => item.type === ELicenseType.OTHER)[0],
        },
    };
};

export const useLicenseInfo = (isAva?: boolean, scheduleToken?: string): [LicenseForm, boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState<LicenseForm>(DefaultLicense);
    const isAvaParam = isAva || getUrlParam('isAva') === 'true';
    const [getResumeInfo] = uniprofileResumeStore.useStore();
    const getResumeData = () => {
        const resumeData = getResumeInfo('data') as INewUniprofileResume;
        if (resumeData?.license) {
            setServiceData(formatLicenseData(resumeData.license));
        }
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getLicense(scheduleToken);
            if (!result.error) {
                const res: ILicense = result?.data?.data || {};
                const data: LicenseForm = formatLicenseData(res);
                setServiceData(data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (isAvaParam) {
            getResumeData();
        } else {
            fetchData();
        }
    }, []);

    return [serviceData, loading, fetchData];
};
